export default {
    /*包括中英文混排截断的逻辑*/
    subString: function (str, length) {
        if(!str){
            return str;
        }
        var str2 = str.replace(/[\u4e00-\u9fa5]/g, "**");
        var new_length = length * 2;
        if (str2.length <= new_length) {
            return str;
        } else {
            var tmp = [];
            for (var i = 0,j=0; i < new_length && j<str.length;) {
                var reg = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
                tmp.push(str[j]);
                j++;
                if (/[\u4e00-\u9fa5]/.test(str[j])){
                    i = i + 2;
                }else if (reg.test(str[j])) {
                    i = i + 2;
                }else{
                    i++;
                }
            }
            return tmp.join("")+"...";
        }
    },
    checkPhoneNumber: function(phoneNumber){
        // 使用正则表达式检查是否符合手机号格式
        const phoneRegex = /^[1-9]\d{10}$/;
        // 检查是否匹配正则表达式
        const isValid = phoneRegex.test(phoneNumber);
        return isValid;
    },
    checkEmail(email){
        // 使用正则表达式检查邮箱格式
        const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        return regex.test(email)
    },
}